import imageCompression from 'browser-image-compression';
import { useState, useEffect } from 'react';


// Compresses an image and returns a URL to the compressed image
async function compressAndRenderImage(imageUrl) {
    try {
        // Fetch the image as a blob
        const response = await fetch(imageUrl);
        const imageBlob = await response.blob();

        // Compress the image with lossy compression options
        const options = {
            maxSizeMB: 1,              // Maximum file size (MB)
            maxWidthOrHeight: 1920,   // Resize image dimensions
            useWebWorker: true,       // Use web workers for faster performance
        };
        const compressedBlob = await imageCompression(imageBlob, options);

        // Convert the compressed image back to a URL
        const compressedImageUrl = URL.createObjectURL(compressedBlob);

        // Use the compressed image URL in your component
        return compressedImageUrl;

    } catch (error) {
        console.error('Image compression failed:', error);
        return imageUrl; // Fallback to original image
    }
}


// InfoPopupImage is a component that displays an image from Flickr in the NodeInfoPopup
export function InfoPopupImage({ selectedNode }) {
    const [compressedImageUrl, setCompressedImageUrl] = useState(null);

    useEffect(() => {
        // Compress and set the image on component mount
        compressAndRenderImage(selectedNode.image_url).then(setCompressedImageUrl);
    }, [selectedNode.image_url]);

    return (
        <img
            src={compressedImageUrl}
            style={{ width: '50%', borderRadius: '1rem' }}
            alt={selectedNode.owner_name ? `This comment's post is from Flickr user ${selectedNode.owner_name}` : 'Invalid URL, or compression failed...'}
        />
    );
}

